<div class="container">
    <div [ngClass]="{ 'row':  label != 'Move to Interview' }">
        <div class="col-xs-12">
            <form #moveJobMatchStepForm="ngForm" novalidate>
                <div class="row">
                    <div class="col-xs-12 job-match-status-statement">
                        <span *ngIf="moveType == 'Forward' || moveType == 'Backward'">
                            <span>Moving candidate </span>
                            <span *ngIf="labelLoadingFlag" style="padding-left: 10px;">
                                <span class="fa fa-spinner fa-spin"></span>
                            </span>
                            <span *ngIf="!(labelLoadingFlag)">
                                '<span [innerHtml]="candidateJobMatch.name" class="emerald"></span>' to
                                '<span class="emerald" [innerHtml]="moveTypeLabel"></span>' for the role of '<span class="emerald" [innerHtml]="candidateJobMatch.jobMatchTitle"></span>'
                                <span *ngIf="candidateJobMatch.jobMatchClientName != null">at '<span class="emerald">{{candidateJobMatch.jobMatchClientName }}</span>'</span>
                            </span>
                        </span>
                        <span *ngIf="moveType == 'Skip'">
                            <span>{{moveTypeLabel}} </span>
                            <span *ngIf="labelLoadingFlag" style="padding-left: 10px;">
                                <span class="fa fa-spinner fa-spin"></span>
                            </span>
                            <span *ngIf="!(labelLoadingFlag)">
                                for the candidate '<span [innerHtml]="candidateJobMatch.name" class="emerald"></span>' for the role of '<span class="emerald" [innerHtml]="candidateJobMatch.jobMatchTitle"></span>'
                                <span *ngIf="candidateJobMatch.jobMatchClientName != null">at '<span class="emerald">{{ candidateJobMatch.jobMatchClientName }}</span>'</span>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-xs-12">
                        <div class="form-group" [ngClass]="{ 'has-error': (moveJobMatchStepForm.submitted && notes.invalid) }">
                            <label for="notes" class="control-label">
                                Internal Notes<em>*</em> :
                            </label>
                            <!-- Voice Input -->
                            <div class="mb-2">
                                <app-voice-input 
                                    (transcriptReady)="onVoiceTranscript($event)"
                                    [sourceScreen]="sourceScreen"
                                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                                </app-voice-input>
                            </div>
                            <textarea #notes="ngModel" id="notes" name="notes" class="form-control" rows="3" placeholder="Enter your note.."
                                [(ngModel)]="moveData.notes"
                                (ngModelChange)="candidateJobMatch.isSharedRequisition && copyNote && onInternalNoteChanged()" required>
                            </textarea>
                            <!-- Formalize Text -->
                            <app-formalize-comment 
                                [inputText]="moveData.notes" 
                                (outputText)="receiveFormalizedComment($event)"
                                [sourceScreen]="sourceScreen"
                                [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                            </app-formalize-comment>
                            </div>
                    </div>
                    <div class="col-xs-12" *ngIf="candidateJobMatch.isSharedRequisition">
                        <app-external-notes 
                            [form]="moveJobMatchStepForm" 
                            [note]="moveData.notes"
                            [externalNote]="moveData.externalNote"
                            [copyNote]="copyNote"
                            (onExternalNoteChange)="onExternalNoteChange($event)"
                            (onCopyNoteChange)="onCopyNoteChange($event)"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </app-external-notes>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-right">
                        <div class="clearfix">
                            <button type="submit" class="btn btn-success" (click)="moveJobMatchStep()" [disabled]="savingFlag">
                                <span *ngIf="!savingFlag">{{saveLabel}}</span>
                                <span *ngIf="savingFlag">{{savingLabel}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>